import { useEffect, useRef } from "react";

export const useBarcodeScanner = (onScan) => {
  const barcodeBuffer = useRef("");
  const lastKeyTime = useRef(Date.now());

  useEffect(() => {
    const handleKeyDown = (e) => {
      // Ignore if user is typing in an input field
      if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA" || e.target.tagName === "SELECT") {
        return;
      }

      const currentTime = Date.now();
      
      // If time since last key is too long (> 50ms), it's probably a human typing, not a scanner.
      // Scanners are fast.
      if (currentTime - lastKeyTime.current > 100) {
        barcodeBuffer.current = "";
      }
      
      lastKeyTime.current = currentTime;

      // Enter key marks the end of the scan
      if (e.key === "Enter") {
        if (barcodeBuffer.current.length >= 3) {
          onScan(barcodeBuffer.current);
          e.preventDefault();
        }
        barcodeBuffer.current = "";
      } else if (e.key.length === 1 && !e.ctrlKey && !e.altKey && !e.metaKey) {
        barcodeBuffer.current += e.key;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onScan]);
};

